import { render, staticRenderFns } from "./TrashDocument.vue?vue&type=template&id=7d312d7c&"
import script from "./TrashDocument.vue?vue&type=script&lang=js&"
export * from "./TrashDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports